import React from 'react';

export function OpsScreenHeader({
  kicker,
  question,
  detail,
}: {
  kicker: string;
  question: string;
  detail?: string;
}) {
  return (
    <header className="shrink-0">
      <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--text-muted)]">{kicker}</p>
      <h1 className="mt-0.5 text-[15px] font-semibold leading-snug text-[var(--text-primary)]">{question}</h1>
      {detail ? <p className="mt-0.5 text-[11px] text-[var(--text-secondary)]">{detail}</p> : null}
    </header>
  );
}

export function OpsSubnav<T extends string>({
  items,
  value,
  onChange,
}: {
  items: Array<{ id: T; label: string }>;
  value: T;
  onChange: (id: T) => void;
}) {
  return (
    <div className="flex shrink-0 items-end gap-1 border-b border-[var(--border-default)]/70" role="tablist">
      {items.map((item) => {
        const active = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.id)}
            className={`-mb-px border-b-2 px-2.5 py-1.5 text-[11px] font-medium transition-colors ${
              active
                ? 'border-[var(--nav-active-bar)] text-[var(--text-primary)]'
                : 'border-transparent text-[var(--text-muted)] hover:text-[var(--text-secondary)]'
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export function OpsSimScopeNote({ active, affects }: { active: boolean; affects: boolean }) {
  if (!active || affects) return null;
  return (
    <p className="shrink-0 text-[10px] text-[var(--text-muted)]">
      Simulação ativa no Ao Vivo e na Carga. Esta visão não entra no cenário simulado.
    </p>
  );
}

export function OpsSimActiveBadge() {
  return (
    <span className="rounded-[3px] bg-violet-500/20 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wide text-violet-300">
      Simulação ativa
    </span>
  );
}
